import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "button-container" }


import { ref, defineComponent, defineProps, onMounted, defineEmits } from 'vue'
import { apiPostData, getI18n, isEmptyString, deepCopy, isEmptyArray, showRequestResult, combinateUrlQueryStr } from '../utils'
import { qrcodeUrl } from '../config'
import store from '../store'

import DropDownSelector from './DropDownSelector.vue'
import CascaderSelector from './CascaderSelector.vue'
import DatePicker from './DatePicker.vue'
import ImageItem from './ImageItem.vue'
import UploadSingleFileKit from './UploadSingleFileKit.vue'

import { ElMessage } from 'element-plus'

const __default__ = defineComponent({
  name: 'TableDataDlg',
  components: {
    DropDownSelector,
    CascaderSelector,
    ImageItem,
    DatePicker,
    UploadSingleFileKit
  }
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  // dialog 的数据
  data: {
    type: Object,
    require: true
  },
  // 这变量单独剥离出来，方便控制窗口的显示
  dialogIndex: {
    type: Number,
    required: true
  }
},
  emits: ["onOk", "onCancel"],
  setup(__props, { emit: __emit }) {

const props = __props

// eslint-disable-next-line
const modelValues = ref({} as {[key: string]: any})
const refItemList = ref([])
const isVisible = ref(true)

onMounted(async () => {
  refItemList.value = deepCopy(props.data.itemList)
  if (isEmptyArray(refItemList.value)) {
    return
  }
  modelValues.value = {}

  // 构建每行的查询参数
  const queryStringArr: string[] = []
  for (let i = 0; i < refItemList.value.length; i++) {
    const key = refItemList.value[i].key
    const dataValue = refItemList.value[i].dataValue
    if (dataValue === undefined) {
      continue
    }
    refItemList.value[i].dataValue = String(refItemList.value[i].dataValue)
    modelValues.value[key] = String(dataValue)
    if (!isEmptyString(dataValue) && typeof dataValue === 'string' && !dataValue.startsWith('http://') && !dataValue.startsWith('https://')) {
      queryStringArr.push(`${key}=${dataValue}`)
    }
  }
  const queryString = queryStringArr.join('&')

  console.log('TableDataDlg onMounted')
  // 传个每个元素的值
  for (let i = 0; i < refItemList.value.length; i++) {
    if (!isEmptyString(refItemList.value[i].srcDataUrl)) {
      const url = combinateUrlQueryStr(refItemList.value[i].srcDataUrl, queryString)
      refItemList.value[i].srcDataUrl = url
    }
    if (refItemList.value[i].tagInEditDlg === 'ImageItem') {
      let url = ''
      if (refItemList.value[i].prop === 'qrcode__') {
        if (isEmptyString(refItemList.value[i].dataValue)) {
          url = combinateUrlQueryStr(qrcodeUrl, queryString)
        } else {
          url = combinateUrlQueryStr(refItemList.value[i].dataValue, queryString)
        }
      } else {
        url = combinateUrlQueryStr(refItemList.value[i].dataValue, queryString)
      }
      url = combinateUrlQueryStr(url, `authorizationToken=${store.state.authorizationToken}`)
      refItemList.value[i].dataValue = url
    }
  }
})
const emits = __emit

let isDealing = false
function setKeyValue (data:object, key:string, value:string) {
  if (value === undefined) {
    data[key] = value
  } else if (typeof value !== 'string') {
    data[key] = value
  } else {
    if (!value.startsWith('__uploade&&&')) {
      data[key] = value
    } else {
      // 1. 以 "__uploade&&&" 开头, 上传文件
      // 2. 按 "&&&" 分割字符串
      const parts = value.split('&&&')
      data[key] = parts[1]
      data[key + '__ori_filename'] = parts[2]
    }
  }
}
function onOk () {
  if (isDealing) {
    return
  }
  isDealing = true
  // eslint-disable-next-line
  const data = {} as {[key: string]: any}
  // eslint-disable-next-line
  const itemList = props.data!.itemList
  for (let i = 0; i < itemList.length; i++) {
    const key = itemList[i].key
    if (itemList[i].filedType !== undefined) {
      if (itemList[i].filedType === 'number') {
        data[key] = Number(modelValues.value[key])
      } else {
        // data[key] = modelValues.value[key]
        setKeyValue(data, key, modelValues.value[key])
      }
    } else {
      // data[key] = modelValues.value[key]
      setKeyValue(data, key, modelValues.value[key])
    }
  }

  ElMessage({
    type: 'success',
    message: 'send request to server'
  })

  // eslint-disable-next-line
  apiPostData(props.data!.url, data)
    .then(response => {
      const prefixOk = data.editOkBtnName ? data.editOkBtnName : getI18n('确定')
      showRequestResult(response, prefixOk, prefixOk, getI18n('请求结果'), true, true, true, (result) => {
        isDealing = false
        if (result?.success) {
          emits('onOk', props, response, result)
        }
      })
    }).catch(error => {
      console.error('Error:', error)
      isDealing = false
    })
}
function onCancel () {
  emits('onCancel', props)
}
const handleClose = (done: () => void) => {
  emits('onCancel', props)
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: isVisible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isVisible).value = $event)),
    title: _unref(getI18n)(__props.data.title),
    width: __props.data.dialogWidth,
    "before-close": handleClose,
    draggable: true,
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_scrollbar, {
        "max-height": "100vh",
        style: {"padding-right":"15px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(refItemList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: item.key,
                  label: _unref(getI18n)(item.label),
                  "label-width": __props.data.formLabelWidth+'px',
                  class: _normalizeClass({ 'required-field': item.isRequired })
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(item.tag), _mergeProps(item, {
                      modelValue: modelValues.value[item.key],
                      "onUpdate:modelValue": ($event: any) => ((modelValues.value[item.key]) = $event)
                    }), null, 16, ["modelValue", "onUpdate:modelValue"]))
                  ]),
                  _: 2
                }, 1032, ["label", "label-width", "class"]))
              }), 128))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (onCancel()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getI18n)('取消')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (onOk()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.data.editOkBtnName ? _unref(getI18n)(__props.data.editOkBtnName) : _unref(getI18n)('确定')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "title", "width"]))
}
}

})